import { ActionButtonProps, Box, Button, Form, Icon, ModBox, required, Spacer, Text, TextProps } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { useStores } from '../../../data/store'
import { Routes } from '../../../nav/routes'
import { Colors } from '../../../util/util'
import { EducationFee } from './EducationFee'
import SelectCity from './SelectCity'

export const SelectStateCity = ({ headerTitle, hide }: any) => {
  const { updateLocationInfo } = useStores((root) => ({
    updateLocationInfo: root.billPayments.updateIntituteLocationInfo,
  }))

  const navigation = useNavigation()

  const getInitialValues = () => {
    return {
      state: '',
      city: '',
    }
  }

  if (hide) {
    return null
  }

  const renderActionButton = ({ title, isValid, values }: ActionButtonProps) => {
    // console.log('values', values)
    const billFetch = async () => {
      await updateLocationInfo({ state: values?.state, city: values?.city })
      navigation.navigate(Routes.INSTITUTE_LIST as never, { title: headerTitle } as never)
    }
    return (
      <Button
        height={48}
        isRound
        testID={'FormProceed'}
        disabled={!isValid}
        onPress={billFetch}
        type="primary"
        isFull={true}
        color="PRIMARY"
        underlayColor="PRIMARY">
        <Text fontSize={16} color="WHITE" fontFamily="JioType-Bold">
          {title}
        </Text>
      </Button>
    )
  }
  return (
    <ModBox f={1} ph={24}>
      <Box f={1}>
        <Box maxWidth={'80%'} pb={41} pt={10}>
          <Text testID="title" {...styles.title}>
            Select State & City of the Institute
          </Text>
        </Box>

        <Form
          container={({ children }) => (
            <Box flex={1} pb={24} justify="space-between">
              {children}
            </Box>
          )}
          formData={getFormFieldArray() as any}
          actionButtons={renderActionButton as any}
          initialValues={getInitialValues()}
        />
      </Box>
    </ModBox>
  )
}

const rightComp = (
  <Box width={24} height={24} align="center" justify="center">
    <Icon id="ARROW_DOWN" size={24} color={Colors.PRIMARY} />
  </Box>
)

const getFormFieldArray = () => {
  const retData = [
    {
      formItems: [
        {
          fieldName: 'state',
          ComponentName: EducationFee,
          height: 48,
          label: 'State',
          placeholder: 'Select State',
          validationSchema: required,
          fontSize: 16,
          labelFontSize: 14,
          borderColor: '#b5b5b5',
          selectionColor: Colors.PRIMARY,
          placeholderTextColor: Colors.PRIMARY_GREY,
          rightComponent: rightComp,
        },
        {
          fieldName: 'spacer',
          ComponentName: Spacer,
          size: 33,
          direction: 'vertical',
        },
        {
          fieldName: 'city',
          label: 'City',
          placeholder: 'Select City',
          validationSchema: required,
          ComponentName: SelectCity,
          height: 48,
          fontSize: 16,
          labelFontSize: 14,
          borderColor: '#b5b5b5',
          selectionColor: Colors.PRIMARY,
          placeholderTextColor: Colors.PRIMARY_GREY,
          rightComponent: rightComp,
        },
        {
          fieldName: 'spacer',
          ComponentName: Spacer,
          size: 33,
          direction: 'vertical',
        },
      ],
      verticalSpacing: 0,
      onSubmit: async () => {
        return 'end'
      },
      actionTitle: 'Contine',
    },
  ]
  return retData
}

const styles = {
  title: {
    fontFamily: 'JioType-Black',
    fontSize: 18,
    lineHeight: 24,
    letterSpacing: -0.08,
    color: Colors.BLACK_14,
  } as TextProps,
}
